import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Download } from "lucide-react";
import API_URL from "../Config";
import MigArchCredit from "../Components/MigArchCredit";
import BoardCanvas from "./BoardCanvas";
import "./Moodboard.css";

export default function SharedMoodboard() {
  const { token } = useParams();
  const [board, setBoard] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const previousTitle = document.title;
    return () => {
      document.title = previousTitle;
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/public/moodboards/${encodeURIComponent(token)}`)
      .then(({ data }) => {
        setBoard(data);
        document.title = `${data.title} · JUMIG Store`;
      })
      .catch((err) =>
        setError(
          err.response?.status === 404
            ? "This link is no longer available. Ask the person who shared it for a new one."
            : "Could not load this board. Please try again."
        )
      );
  }, [token]);

  const exportUrl = (format, page) =>
    `${API_URL}/api/public/moodboards/${encodeURIComponent(token)}/export?format=${format}${page ? `&page=${page}` : ""}`;
  const pages = board?.pages?.length ? board.pages : board ? [{ id: "page-1", background: board.background, items: board.items }] : [];

  return (
    <div className="mb-shared">
      <header className="mb-shared-head">
        <a href="https://jumigstore.com" target="_blank" rel="noopener noreferrer" aria-label="JUMIG Store">
          <img src="/logo-jumig-store.png" alt="JUMIG Store" className="mb-shared-logo" />
        </a>
        {board && (
          <div className="mb-shared-actions">
            {pages.length === 1 && (
              <a className="mb-tool" href={exportUrl("png")}>
                <Download size={16} strokeWidth={1.8} aria-hidden="true" />
                PNG
              </a>
            )}
            <a className="mb-primary" href={exportUrl("pdf")}>
              <Download size={16} strokeWidth={1.8} aria-hidden="true" />
              Download PDF
            </a>
          </div>
        )}
      </header>

      <main className="mb-shared-body">
        {error && <p className="mb-error">{error}</p>}
        {!board && !error && <p className="mb-muted">Loading board...</p>}
        {board && (
          <>
            <div className="mb-shared-title">
              <p className="mb-kicker">Mood board</p>
              <h1>{board.title}</h1>
              {board.shared_by && <p>Prepared by {board.shared_by}</p>}
            </div>
            {pages.map((page, index) => (
              <section key={page.id} className="mb-shared-page" aria-label={`Board ${index + 1}`}>
                {pages.length > 1 && (
                  <div className="mb-shared-page-head">
                    <span>
                      Board {index + 1} of {pages.length}
                    </span>
                    <a className="mb-text-button" href={exportUrl("png", index + 1)}>
                      <Download size={14} strokeWidth={1.8} aria-hidden="true" />
                      PNG
                    </a>
                  </div>
                )}
                <div className="mb-shared-board">
                  <BoardCanvas board={{ aspect: board.aspect, background: page.background, items: page.items }} assets={board.assets} fit />
                </div>
              </section>
            ))}
            <p className="mb-shared-note">
              The PDF includes a page listing every JUMIG Store design on this board, with names to quote when
              ordering.
            </p>
          </>
        )}
      </main>

      <footer className="mb-shared-foot">
        <p>
          © {new Date().getFullYear()} JUMIG Store ·{" "}
          <a href="https://jumigstore.com" target="_blank" rel="noopener noreferrer">
            jumigstore.com
          </a>
        </p>
        <MigArchCredit />
      </footer>
    </div>
  );
}
